"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_CREATE_PRODUCT_FLAVOR = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.SABRE_CREATE_PRODUCT_FLAVOR = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateFlavor($input: CreateFlavorInput!) {\n    createFlavor(input: $input) {\n      flavor {\n        ...Flavor\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateFlavor($input: CreateFlavorInput!) {\n    createFlavor(input: $input) {\n      flavor {\n        ...Flavor\n      }\n    }\n  }\n  ", "\n"])), fragments_1.SABRE_FLAVOR_FRAGMENT);
var templateObject_1;
